// extracted by mini-css-extract-plugin
export default {"coustomScrollBar":"field_coustomScrollBar__KKu7S"};